
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BoatProvider } from "@/context/BoatContext";
import { AuthProvider } from "@/context/AuthContext";
import { VisitorTracker } from "@/components/tracking/VisitorTracker";
import CookieConsentBanner from "@/components/rgpd/CookieConsentBanner";
import Index from "./pages/Index";
import HomePage from "./pages/HomePage";
import BoatsPage from "./pages/BoatsPage";
import MaintenancePage from "./pages/MaintenancePage";
import InventoryPage from "./pages/InventoryPage";
import AssistantNautiquePage from "./pages/AssistantNautiquePage";
import AuthPage from "./pages/AuthPage";
import AccountPage from "./pages/AccountPage";
import MesBateauxPage from "./pages/MesBateauxPage";
import BateauDetailPage from "./pages/BateauDetailPage";
import ChecklistsPage from "./pages/ChecklistsPage";
import FAQPage from "./pages/FAQPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import CGVPage from "./pages/CGVPage";
import CGUPage from "./pages/CGUPage";
import { AdminPage } from "./pages/AdminPage";
import NotFound from "./pages/NotFound";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import PortDetailPage from "./pages/PortDetailPage";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <BoatProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <VisitorTracker />
            <CookieConsentBanner />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/dashboard" element={<Index />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/mes-bateaux" element={<MesBateauxPage />} />
              <Route path="/navire/:id" element={<BateauDetailPage />} />
              <Route path="/boats" element={<BoatsPage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/checklists" element={<ChecklistsPage />} />
              <Route path="/assistant" element={<AssistantNautiquePage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
              <Route path="/cgv" element={<CGVPage />} />
              <Route path="/cgu" element={<CGUPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/ports/:id" element={<PortDetailPage />} />
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </BoatProvider>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
